module.exports = __webpack_public_path__ + "static/highlight-2984b8fd4bdfe193b589ac256bfd2fa2.jpg";